// extracted by mini-css-extract-plugin
module.exports = {"quizCard":"styles_quizCard__gbbXD","quizAnswers":"styles_quizAnswers__2PylF"};